import { CardCvcElement } from "@stripe/react-stripe-js";
import type { StripeCardCvcElementChangeEvent } from "@stripe/stripe-js";
import { FieldShell } from "@freightsimple/ui-core/Controls/FieldShell";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { useControlValueTextStyle } from "@freightsimple/ui-core/Controls/useControlValueTextStyle";
import { useThemeContext } from "@freightsimple/ui-core/Theme/useThemeContext";

import { useState } from "react";
import { creditCardsStripeFieldOptions } from "@/Shared/CreditCards/Helpers/creditCardsStripeFieldOptions";

interface CreditCardCVCProps {
  onError: (message: ErrorMessageType) => void;
  errorMessage: ErrorMessageType;
  forceValidation: boolean;
}

// Stripe CVC iframe inside a ui-core FieldShell. Red border + message come from
// the wrapping FormItem (CreditCardsCardPanel); focus border is driven off Stripe's own
// focus/blur events.
function CreditCardsCVC(props: CreditCardCVCProps) {
  const { resolvedTheme } = useThemeContext();
  const valueText = useControlValueTextStyle();
  const [focused, setFocused] = useState(false);
  return (
    <FieldShell focused={focused} data-testid="credit-card-cvc">
      <CardCvcElement
        options={creditCardsStripeFieldOptions(resolvedTheme, valueText)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(event: StripeCardCvcElementChangeEvent) => {
          props.onError(event.error?.message);
        }}
      />
    </FieldShell>
  );
}
export default CreditCardsCVC;
